import { useCallback, useEffect, useRef, useState } from "react";

const VERSION_URL = "/version.json";
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

const currentBuildId = import.meta.env.VITE_BUILD_ID as string | undefined;

// Detecta si hay una nueva versión desplegada consultando periódicamente
// version.json (generado en cada build, ver vite.config.ts) y comparando
// su buildId con el de este bundle. No usa service worker a propósito:
// ver src/serviceWorker.ts sobre los problemas de caché en Samsung.
const useAppUpdate = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const checkingRef = useRef(false);

  const checkForUpdate = useCallback(async () => {
    if (import.meta.env.DEV || !currentBuildId || checkingRef.current) {
      return;
    }
    checkingRef.current = true;
    try {
      const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
        cache: "no-store",
      });
      if (response.ok) {
        const data = await response.json();
        if (data.buildId && data.buildId !== currentBuildId) {
          setUpdateAvailable(true);
        }
      }
    } catch {
      // Fallo de red puntual: se reintenta en el siguiente ciclo
    } finally {
      checkingRef.current = false;
    }
  }, []);

  useEffect(() => {
    checkForUpdate();
    const intervalId = window.setInterval(checkForUpdate, CHECK_INTERVAL_MS);
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        checkForUpdate();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [checkForUpdate]);

  const applyUpdate = useCallback(() => {
    window.location.reload();
  }, []);

  return { updateAvailable, applyUpdate };
};

export default useAppUpdate;
